<template>
  <div id="app">
      <the-header></the-header>
      <transition name="fade" mode="out-in">
        <router-view ></router-view>
      </transition>
      <the-footer></the-footer>
  </div>
</template>

<script>
import TheHeader from '@/components/TheHeader';
import TheFooter from '@/components/TheFooter';
export default {
    components: {
        TheHeader,
        TheFooter
    },
    data() {
      return {
      }
    },
    metaInfo() {
      return {
          title: 'Veiligheidsteam.nl',
          titleTemplate: '%s | ' + this.$route.meta.title,
          link: [
              { rel: 'canonical', href: (!!this.$route.meta.canonical) ? this.$route.meta.canonical : window.location.href }
          ],
          htmlAttrs: {
              lang: 'nl',
              //amp: true
          },
          meta: [
              { name: 'description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Veiligheidsteam verzorgd de totale ontzorging van veiligheidsvraagstukken. Van analyse en plan tot de uitvoering en het leveren van een team veiligheidsprofessionals.' },
              { name: 'keywords', content: (!!this.$route.meta.keywords) ? this.$route.meta.keywords : 'Veiligheid, Risicoanalyse, Beveiliging, Beveiliger, Crowd, Management, Beveiligingsplan, Veiligheidsplan, Evacuatieplan, Plan, Security, Beveiliginsbedrijf, Objectbeveiliger, Winkelsurveillance, Evenementenbeveiliger, Receptionist, Persoonsbeveiliger, Brandwacht, Verkeersregelaar, EHBO' },
              
              { property: 'og:title', content: 'Veiligheidsteam.nl ← ' + this.$route.meta.title },
              { property: 'og:site_name', content: 'Veiligheidsteam.nl'},
              { property: 'og:type', content: 'website'},
              { property: 'og:url', content: (!!this.$route.meta.canonical) ? this.$route.meta.canonical : window.location.href },
              { property: 'og:image', content: (!!this.$route.meta.image) ? this.$route.meta.image : 'https://veiligheidsteam.nl/img/icons/icon-512x512.png' },
              { property: 'og:description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Veiligheidsteam verzorgd de totale ontzorging van veiligheidsvraagstukken. Van analyse en plan tot de uitvoering en het leveren van een team veiligheidsprofessionals.'},

              { name: 'twitter:card', content: 'summary'},
              { name: 'twitter:site', content: (!!this.$route.meta.canonical) ? this.$route.meta.canonical : window.location.href },
              { name: 'twitter:title', content: 'Veiligheidsteam.nl ← ' + this.$route.meta.title},
              { name: 'twitter:description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Veiligheidsteam verzorgd de totale ontzorging van veiligheidsvraagstukken. Van analyse en plan tot de uitvoering en het leveren van een team veiligheidsprofessionals.'},
              { name: 'twitter:creator', content: 'info@veiligheidsteam.nl'},
              { name: 'twitter:image:src', content: (!!this.$route.meta.image) ? this.$route.meta.image : 'https://veiligheidsteam.nl/img/icons/icon-512x512.png' },

              { itemprop: 'name', content: 'Veiligheidsteam.nl ← ' + this.$route.meta.title},
              { itemprop: 'description', content: (!!this.$route.meta.description) ? this.$route.meta.description : 'Veiligheidsteam verzorgd de totale ontzorging van veiligheidsvraagstukken. Van analyse en plan tot de uitvoering en het leveren van een team veiligheidsprofessionals.'},
              { itemprop: 'image', content: (!!this.$route.meta.image) ? this.$route.meta.image : 'https://veiligheidsteam.nl/img/icons/icon-512x512.png' }

          ]
      }
    }
};
</script>

<style lang="scss">
@import "~bootstrap/scss/bootstrap";
@import "@/assets/styles.scss";
@import "@/assets/buttons.scss";
@import "@/assets/transitions.scss";

body {
  background-color: #ffffff;
}

a {
  color: $primaryColor;
}
a:hover {
  color: $primaryColor;
}

#app {
  font-family: 'Ubuntu', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: $darkColor;
  .margin-top {
    margin-top: 71px;
  }
}

.brand {
    font-weight: bold;
    color: $darkColor;

    p.text-muted {
        text-align: center;
        font-size: .8rem;
        letter-spacing: .1rem;
        margin: 0;
        margin-top:-5px;
    }
}

.vertical-center {
  margin: 0;
  position: absolute;
  top: 50%;
  left:0;
  right: 0;
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
}

.top {
  position: absolute;
  top:0;
  left: 0;
  right: 0;
  margin: auto;
  height: 65%;
  background-color: $darkColor;
}

.primary {
  color: $primaryColor;
}

.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}

.inline {
  display: inline-block;
}

.ellipsis {
  white-space: nowrap; 
  overflow: hidden;
  text-overflow: ellipsis;
}

.light-link,
.light-link:hover {
  color: $lightColor;
}

.region a {
  color: $lightColor;
}

.region a:hover {
  text-decoration: underline;
}

.fade-enter-active,
.fade-leave-active {
  transition-duration: 0.3s;
  transition-property: opacity;
  transition-timing-function: ease;
}

.fade-enter,
.fade-leave-active {
  opacity: 0
}

@media only screen and (max-width: 768px) {
  .visible-sm {
    visibility: visible;
  }
  .invisible-sm {
    visibility: hidden;
    display: none !important;
  }
}

@media only screen and (min-width: 768px) {
  .visible-md {
    visibility: visible;
  }
  .invisible-md {
    visibility: hidden;
    display: none !important;
  }
}
</style>
